
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FiArrowLeft, FiArrowDownCircle, FiInfo, FiCheckCircle, FiArrowUpRight } from "react-icons/fi";
import {
  BsWallet2,
  BsCurrencyRupee,
  BsShieldCheck,
  BsLightningChargeFill,
} from "react-icons/bs";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import { apiRequest } from "../../apiService/allApi";
import "../css/BoxLudoRedeem.css";

const Redeem = ({ walletUpdate, user }) => {
  const history = useHistory();

  const [amount, setAmount] = useState("");
  const [userAllData, setUserAllData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const MIN_AMOUNT = 100;
  const MAX_AMOUNT = 10000;

  const quickAmounts = [100, 500, 1000, 2000];

  // ==============================
  // FETCH USER PROFILE
  // ==============================
  const role = async () => {
    try {
      socket.emit("getprofile");

      const accessToken = localStorage.getItem("token");

      if (!accessToken) {
        history.push("/login");
        return;
      }

      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const res = await apiRequest("me", "GET", null, headers);

      setUserAllData(res?.data || null);
    } catch (error) {
      console.error("Redeem profile error:", error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    role();
  }, []);

  // ==============================
  // AMOUNT VALIDATION
  // ==============================
  const amountNumber = Number(amount);

  const isAmountValid =
    amount !== "" &&
    Number.isFinite(amountNumber) &&
    amountNumber >= MIN_AMOUNT &&
    amountNumber <= MAX_AMOUNT;

  const getAmountError = () => {
    if (amount === "") return "";

    if (!Number.isFinite(amountNumber)) {
      return "Please enter a valid amount.";
    }

    if (amountNumber < MIN_AMOUNT) {
      return `Minimum redeem amount is ₹${MIN_AMOUNT}.`;
    }

    if (amountNumber > MAX_AMOUNT) {
      return `Maximum redeem amount is ₹${MAX_AMOUNT.toLocaleString("en-IN")}.`;
    }

    return "";
  };

  // ==============================
  // QUICK AMOUNT SELECTION
  // ==============================
  const selectAmount = (value) => {
    setAmount(String(value));
  };

  // ==============================
  // REDEEM REFERRAL BALANCE
  // ==============================
  const deposit = async () => {
    if (loading) return;

    if (!isAmountValid) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Amount",
        text: `Enter an amount between ₹${MIN_AMOUNT} and ₹${MAX_AMOUNT.toLocaleString("en-IN")}.`,
        confirmButtonText: "Okay",
        customClass: {
          popup: "box-redeem-swal",
          confirmButton: "box-redeem-swal-button",
        },
        buttonsStyling: false,
      });

      return;
    }

    try {
      setLoading(true);

      const accessToken = localStorage.getItem("token");

      if (!accessToken) {
        history.push("/login");
        return;
      }

      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const res = await apiRequest(
        "referral/to/wallet",
        "POST",
        { amount: amountNumber },
        headers
      );

      const responseData = res?.data;

      if (
        responseData?.msg === "Invalid Amount" ||
        responseData?.success === false
      ) {
        Swal.fire({
          icon: "warning",
          title: "Redeem Failed",
          text:
            responseData?.message ||
            "You don't have sufficient referral balance.",
          confirmButtonText: "Okay",
          customClass: {
            popup: "box-redeem-swal",
            confirmButton: "box-redeem-swal-button",
          },
          buttonsStyling: false,
        });

        return;
      }

      await Swal.fire({
        icon: "success",
        title: "Redeem Successful!",
        text: `₹${amountNumber.toLocaleString("en-IN")} referral balance has been submitted for transfer.`,
        confirmButtonText: "Great!",
        timer: 2200,
        timerProgressBar: true,
        customClass: {
          popup: "box-redeem-swal",
          confirmButton: "box-redeem-swal-button",
        },
        buttonsStyling: false,
      });

      setAmount("");

      // Refresh parent wallet/profile if callback is supplied.
      if (typeof walletUpdate === "function") {
        walletUpdate();
      }

      // Refresh user information.
      role();
    } catch (error) {
      console.error("Referral redeem error:", error);

      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        text:
          error?.response?.data?.message ||
          error?.response?.data?.msg ||
          "Unable to redeem referral balance. Please try again.",
        confirmButtonText: "Okay",
        customClass: {
          popup: "box-redeem-swal",
          confirmButton: "box-redeem-swal-button",
        },
        buttonsStyling: false,
      });
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div className="box-redeem-page">
        <div className="box-redeem-loader">
          <div className="box-redeem-loader-ring" />
          <span>Loading your wallet...</span>
        </div>
      </div>
    );
  }

  return (
    <>

      <div className="blr-page">
        <div className="blr-container">

          <div className="bl-deposit-banner">
            <img
              src="/images/referal-redeem.png"
              alt=""
              className="bl-deposit-banner-image"
            />
          </div>

          {/* AVAILABLE BALANCE */}
          <section className="blr-balance-card">
            <div className="blr-balance-decoration blr-decoration-one" />
            <div className="blr-balance-decoration blr-decoration-two" />

            <div className="blr-balance-top">
              <div className="blr-wallet-icon">
                <BsWallet2 />
              </div>

              <div className="blr-balance-heading">
                <span>Available Redeem Balance</span>
                <small>Your referral earnings</small>
              </div>

              <span className="blr-available-badge">
                <FiCheckCircle />
                Available
              </span>
            </div>

            <div className="blr-balance-amount">
              <span>₹</span>
              <strong>
                {/* {Number(userAllData?.referral_earning || 0).toLocaleString(
                  "en-IN",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )} */}
                {user?.referral_wallet?.toFixed(2) || "0.00"}
              </strong>
            </div>

            <div className="blr-balance-bottom">
              <span>
                <BsShieldCheck />
                Secure redemption
              </span>

              <span className="blr-balance-tag">
                REFERRAL WALLET
              </span>
            </div>
          </section>





          {/* REDEEM FORM */}
          <section className="blr-form-card">
            <div className="blr-form-heading">
              <div>
                <span className="blr-form-step">YOUR REDEMPTION</span>
                <h2>Enter Amount</h2>
                <p>Choose the amount you want to transfer.</p>
              </div>

              <div className="blr-form-heading-icon">
                <BsCurrencyRupee />
              </div>
            </div>

            {/* INPUT */}
            <label htmlFor="blr-redeem-amount" className="blr-input-label">
              Redemption Amount
            </label>

            <div
              className={`blr-input-wrap ${amount && isAmountValid ? "blr-input-valid" : ""
                } ${amount && !isAmountValid ? "blr-input-invalid" : ""
                }`}
            >
              <span className="blr-input-rupee">₹</span>

              <input
                id="blr-redeem-amount"
                type="number"
                min={MIN_AMOUNT}
                max={MAX_AMOUNT}
                step="1"
                inputMode="numeric"
                value={amount}
                placeholder="Enter amount"
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "") {
                    setAmount("");
                    return;
                  }

                  if (/^\d+$/.test(value)) {
                    setAmount(value);
                  }
                }}
                onKeyDown={(e) => {
                  if (["-", "+", ".", "e", "E"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />

              <span className="blr-input-currency">INR</span>
            </div>

            {amount && !isAmountValid ? (
              <p className="blr-input-message blr-error-message">
                {getAmountError()}
              </p>
            ) : (
              <p className="blr-input-message">
                Minimum ₹100 and maximum ₹10,000 per redemption.
              </p>
            )}




            {/* REDEEM BUTTON */}
            <button
              type="button"
              className="blr-submit-btn"
              onClick={deposit}
              disabled={
                !isAmountValid ||
                loading ||
                Number(amount) > Number(userAllData?.referral_earning || 0)
              }
            >
              {loading ? (
                <>
                  <span className="blr-spinner" />
                  Processing...
                </>
              ) : (
                <>
                  <BsWallet2 />
                  <span>Redeem Now</span>
                  <span className="blr-submit-arrow">→</span>
                </>
              )}
            </button>

            {Number(amount) > Number(userAllData?.referral_earning || 0) &&
              amount !== "" && (
                <p className="blr-error-message blr-balance-error">
                  Insufficient referral balance.
                </p>
              )}

            <div className="blr-secure-footer">
              <BsShieldCheck />
              <span>Your redemption request is protected.</span>
            </div>
          </section>

          {/* FOOTER */}
          <footer className="blr-footer">
            <span className="blr-footer-dot" />
            BOX LUDO <span>·</span> REFERRAL REWARDS
          </footer>

        </div>
      </div>

    </>
  );
};

export default Redeem;
